export default {
  getBodyCondition: (axios, digitalCertificateId) =>
    axios.get(`/api/digitalCertificates/${digitalCertificateId}/bodyCondition`),
  saveBodyCondition: (axios, digitalCertificateId, data) =>
    axios.post(
      `/api/digitalCertificates/${digitalCertificateId}/bodyCondition`,
      data,
    ),
  deleteBodyConditionElement: (axios, digitalCertificateId, bodyElementId) =>
    axios.delete(
      `/api/digitalCertificates/${digitalCertificateId}/bodyCondition/${bodyElementId}`,
    ),
  saveBodyConditionImage: (axios, digitalCertificateId, bodyElementId, data) =>
    axios.post(
      `/api/digitalCertificates/${digitalCertificateId}/bodyCondition/${bodyElementId}/image`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    ),
  deleteBodyConditionImage: (
    axios,
    digitalCertificateId,
    bodyElementId,
    imageId,
  ) =>
    axios.delete(
      `/api/digitalCertificates/${digitalCertificateId}/bodyCondition/${bodyElementId}/image/${imageId}`,
    ),
}
